import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

export const BaseModal = styled.div`
  position: relative;
  width: 100%;
  background: #fff;
  box-shadow: 0 12px 32px rgba(0,0,0,0.18);
`

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1000;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 24px;
	background: rgba(0, 0, 0, 0.4);
`

export const FormModal = styled(BaseModal)`
  max-width: 615px;
  padding: 34px 40px 38px;
`
export const SuccessModal = styled(BaseModal)`
  max-width: 520px;
  padding: 60px 40px;
`

export const CloseButton = styled.button`
	position: absolute;
	top: 20px;
	right: 24px;

	border: none;
	background: transparent;
	cursor: pointer;

	font-size: 34px;
	line-height: 1;
	color: #9a9a9a;
`

export const Title = styled.h2`
	margin: 0 0 14px;
	font-family: 'e-Ukraine-Head', sans-serif;
	font-weight: 500;
	font-size: 20px;
	letter-spacing: -0.02em;
	color: #01924f;

	@media(max-width: 425px) {
	font-size: 16px;
	}
`

export const Description = styled.p`
	margin: 0 0 26px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 137%;
	color: #484848;
`

export const Form = styled.form`
	display: flex;
	flex-direction: column;
`

export const Field = styled.div`
	margin-bottom: 18px;
`

export const Label = styled.label`
	display: block;
	margin-bottom: 10px;

	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 14px;
	line-height: 137%;
	letter-spacing: -0.01em;
	text-align: justify;
	color: #8f8f8f;

	span {
		color: #01924f;
	}
`

const baseInputStyles = css<{ $error?: any }>`
  width: 100%;
  border: none;
  border-bottom: 1px solid ${props => props.$error ? '#ef4444' : '#d9d9d9'};
  background: transparent;
  outline: none;
  font-family: 'e-Ukraine', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333;

  &::placeholder {
    color: #b1b1b1;
  }

  &:focus {
    border-bottom-color: #009245;
  }
`

export const Input = styled.input<{ $error?: any }>`
	${baseInputStyles}
	height: 25px;
`

export const Textarea = styled.textarea<{ $error?: any }>`
	${baseInputStyles}
	min-height: 50px;
	resize: none;
	border: 1px solid ${props => props.$error ? '#ef4444' : '#d9d9d9'};

	padding: 12px 5px;

	&:focus {
		border-color: #009245;
	}
`

export const CheckboxRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 4px 0 14px;
`

export const Checkbox = styled.input<{ $error?: any }>`
	width: 16px;
	height: 16px;
	margin: 0;
	accent-color: #009245;
`

export const CheckboxLabel = styled.label`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 12px;
	line-height: 137%;
	letter-spacing: -0.01em;
	text-align: justify;
	color: #484848;
	cursor: pointer;
`

export const SubmitButton = styled.button`
	width: fit-content;
	min-width: 114px;
	height: 34px;
	padding: 0 18px;

	border: none;
	border-radius: 6px;
	background: #009245;
	color: #fff;
	cursor: pointer;

	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 14px;
	line-height: 1;

	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.92;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
  }
`

export const PrivacyText = styled.p`
	margin: 14px 0 0;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 11px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #000;
`

export const PrivacyLink = styled(Link)`
	text-decoration: underline;
	text-decoration-skip-ink: none;
	color: #0175e1;
`

export const ErrorText = styled.p`
	margin: 6px 0 0;
	font-family: 'e-Ukraine', sans-serif;
	font-size: 12px;
	line-height: 1.3;
	color: #d93025;
`

export const SuccessWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	gap: 20px;
`

export const SuccessText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	line-height: 122%;
	letter-spacing: 0.01em;
	text-align: center;
	color: #484848;
`

export const CaptchaWrapper = styled.div`
  margin: 8px 0;
`
